<template>
	<div>
		<!-- <top></top> -->
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<!-- <p class="text-sm text-666">首页 - 工人简历</p>
				<p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">工人简历</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="bg-white padding-tb-sm margin-bottom">
				<div class="flex margin-bottom-sm padding-lr-sm">
					<p class="titla text-left margin-right-xs text-xs text-666">工 种：</p>
					<p class="flex-sub text-left">
						<span class="margin-right text-xs pointer  pro-item" @click="chosework(item)" :class="workCategroyId == item.id?'text-theme':'text-666'" v-for="(item,index) in profession" :key="index">{{item.work_categroy_name}}</span>
					</p>
				</div>
				<div class="flex margin-bottom-sm padding-lr-sm">
					<p class="titla text-left margin-right-xs  text-xs text-666">城 市：</p>
					<p class="flex-sub text-left">
						<span class="margin-right-sm text-xs pointer  pro-item" @click="choseprovince(item,index)" :class="provinceIndex == index?'text-theme':'text-666'" v-for="(item,index) in provinceList" :key="index">{{item.name}}</span>
					</p>
				</div>
				<div class="flex margin-bottom-sm padding-lr-sm">
					<p class="titla text-left margin-right-xs  text-xs text-666">人员构成：</p>
					<p class="flex-sub text-left">
						<span class="margin-right text-xs pointer  pro-item" @click="chosestaff(item)" :class="staffindex == item.id?'text-theme':'text-666'" v-for="(item,index) in staff" :key="index">{{item.name}}</span>
					</p>
				</div>
				<!-- <div class="flex padding-lr-sm">
					<p class="titla text-left margin-right-xs  text-xs text-666">排序方式：</p>
					<p class="flex-sub text-left">
						<span class="margin-right text-xs pointer  pro-item" @click="chose(sort,item)" :class="item.ischeck?'text-theme':'text-666'" v-for="(item,index) in sort" :key="index">{{item.name}}</span>
					</p>
				</div> -->
			</div>
			<div class="flex">
				<div class="flex-sub">
					<div v-if="total != 0">
						<div v-for="(item,indx) in userList" :key="indx">
							<ResumeList :data="item" :width="786" :height="184" :size="24"></ResumeList>
						</div>
						<div class="pagination">
							<el-pagination
							@current-change="handleCurrentChange"
							  background
							  page-size="6"
							  layout="prev, pager, next"
							  prev-text="上一页"
							  next-text="下一页"
							  :total="total">
							</el-pagination>
						</div>
					</div>
					<div class="text-center" v-else>
						<el-empty description="暂无数据"></el-empty>
					</div>
				</div>
				<div class="margin-left" v-if="newList.length != 0">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm">最新简历</p>
					</div>
					<div v-for="(item,indx) in newList" :key="indx">
						<ResumeList :data="item" :width="387" :height="168" :size="18"></ResumeList>
					</div>
				</div>
			</div>
		</div>
		<right type="2"></right>
		<Group v-if="addgroup" @closepop="closepop" @gocenter="gocenter"></Group>
		<router-view />
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Right from '@/components/public/right.vue';
	import Top from '@/components/public/top.vue';
	import Group from '@/components/public/group.vue';
	import ResumeList from '@/components/list/resume-list.vue';
	export default {
		components: {
			Top,
			Right,
			Group,
			ResumeList
		},
		name: '',
		data() {
			return {
				profession:[],//工 种
				provinceList:[],//城 市
				provinceIndex:0,//
				staff:[
					{
						id: -1,
						name: '全部'
					},
					{
						id: 0,
						name: '个人'
					},
					{
						id: 1,
						name: '班组'
					},
					{
						id: 2,
						name: '施工队'
					},
					{
						id: 3,
						name: '突击队'
					},
				],//人员构成
				staffindex:-1,
				sort:[
					{
						name:'默认排序',
						ischeck:true
					},
					{
						name:'最新排序',
						ischeck:false
					}
				],//排序方式
				addgroup:false,//是否显示入群提醒
				userList:[],//列表
				cityname:"不限",
				workCategroyId:0,
				newList:[],//最新列表
				page:1,
				total:0,//
			}
		},
		created() {
			//显示入群提醒
			Bus.$on('showqun',data=>{
				this.addgroup = true
			})
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','resume')
			this.getUserList()
			this.getUsernewList()
			this.getcity()
			this.getprofession()
		},
		destroyed() {
			// Bus.$off('showqun')
		},
		methods: {
			gocenter(type){
				let query = {}
				if(type == 1){
					query.type = 'resume'
				}else{
					query.type = 'feedback'
				}
				this.$router.push({
					name:'center',
					query
				})
			},
			//城市筛选
			choseprovince(item,index){
				this.provinceIndex = index
				this.cityname = item.name
				this.page = 1
				this.getUserList();
			},
			//分类筛选
			chosework(item){
				this.workCategroyId = item.id
				this.page = 1
				this.getUserList();
			},
			//人员构成筛选
			chosestaff(item){
				this.staffindex = item.id
				this.page = 1
				this.getUserList();
			},
			
			
			back(){
				this.$router.back()
			},
			//获取城市列表
			getcity(){
				this.ajax('get', '/api/work/getCityList', {}, res => {
					if(res.status == 200){
						let list = res.data;
						let obj = {
							id: 0,
							level: 2,
							pid: 0,
							name: '不限',
						}
						list.unshift(obj)
						this.provinceList = list;
						console.log(this.provinceList);
					}
				})
			},
			//获取分类列表
			getprofession(){
				this.ajax('get', '/api/pc/workCategroy/getlist', {
					type:1
				}, res => {
					if(res.status == 200){
						let list = res.data;
						let obj = {
							id: 0,
							work_categroy_name: '不限',
						}
						list.unshift(obj)
						this.profession = list
					}
				})
			},
			
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getUserList();
			},
			/**
			 * 获取招工人列表
			 * */
			getUserList(){
				this.ajax('get', '/api/pc/userInfo/getList', {
					area:this.cityname == '不限'?'':this.cityname,
					stat:6,
					type:this.staffindex == -1?'':this.staffindex,
					workCategroyId:this.workCategroyId == 0?'':this.workCategroyId,
					page:this.page
				}, res => {
					if(res.status == 200){
						console.log('getUserList',res);
						this.userList = res.data.data
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}
				})
			},
			/**
			 * 获取招工人列表
			 * */
			getUsernewList(){
				this.ajax('get', '/api/pc/userInfo/getList', {
					area:this.cityname == '不限'?'':this.cityname,
					stat:3,
					type:'',
					workCategroyId:this.workCategroyId == 0?'':this.workCategroyId,
					page:1
				}, res => {
					if(res.status == 200){
						console.log('getUserList',res);
						this.newList = res.data.data
					}
				})
			},
			/**
			 * 筛选
			 * list Array  要筛选的列表 
			 * item object 选中的筛选
			 * */
			chose(list,item){
				list.map(ele=>{
					ele.ischeck = false
					if(ele.name == item.name){
						item.ischeck = true
					}
				})
			},
			//关闭入群提醒
			closepop(){
				this.addgroup = false
				// Bus.$off('showqun')
			}
		}
	}
</script>

<style scoped lang="less">
	.titla{
		width: 80px;
		word-spacing:25px;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.pro-item:hover{
		color: #09827B;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
</style>



// WEBPACK FOOTER //
// src/view/index/resume.vue